export const setDefaultStateSound = (stateSound: number) => {
  localStorage.setItem('isSoundOn', JSON.stringify(stateSound))
}
